import { combineReducers } from "@reduxjs/toolkit";
import { servicesSlice } from "./services";
import { authSlice } from "./auth";
import { invoicingSlice } from "./invoicing";
import { listingSlice } from "./listing";
import { insightsSlice } from "./insights";
import { openItemsSlice } from "./openItems";
import { fileManagerSlice } from "./fileManager";
import { clientSettingsSlice } from "./clientSettings";
import { invoiceGenerationSlice } from "./invoiceGeneration";
import { reportsSlice } from "./reports";
import { userManagementSlice } from "./userManagement";
import { insightAdvanceSlice } from "./insightsAdvanced";
import { stcoToolsSlice } from "./stcoTools";
import { maintenanceSlice } from "./maintenance";
import { disbursementsSlice } from "./disbursements";
import { gstModuleSlice } from "./gstModule";
import { clientDirectorySlice } from "./clientDirectory";
import { masterDataSlice } from "./masterData";
import { timeSheetSlice } from "./timeSheet";
import { usersProfileSlice } from "./usersProfile";
import { jobsSlice } from "./jobs";
import { complianceCalendarSlice } from "./complianceCalendar";
import { helpModuleSlice } from "./helpModule";
import { schedulingSlice } from "./scheduling";
import { notificationSlice } from "./notification";
import { fixedAssetRegisterSlice } from "./fixedAsset";
import { mySpaceSlice } from "./mySpace";
import { hrmsSlice } from "./hrms";
import { sopModuleSlice } from "./sopModule";
import { thinksToDoSlice } from "./thinksToDo";
import { expenseManagementSlice } from "./expenseManagement";

export const reducers = combineReducers({
  services: servicesSlice.reducer,
  auth: authSlice.reducer,
  invoicing: invoicingSlice.reducer,
  listing: listingSlice.reducer,
  insights: insightsSlice.reducer,
  insightsAdvanced: insightAdvanceSlice.reducer,
  openItems: openItemsSlice.reducer,
  fileManager: fileManagerSlice.reducer,
  clientSettings: clientSettingsSlice.reducer,
  invoiceGeneration: invoiceGenerationSlice.reducer,
  reports: reportsSlice.reducer,
  userManagement: userManagementSlice.reducer,
  stcoTools: stcoToolsSlice.reducer,
  maintenance: maintenanceSlice.reducer,
  disbursements: disbursementsSlice.reducer,
  gst: gstModuleSlice.reducer,
  clientDirectory: clientDirectorySlice.reducer,
  masterData: masterDataSlice.reducer,
  timeSheet: timeSheetSlice.reducer,
  usersProfile: usersProfileSlice.reducer,
  jobs: jobsSlice.reducer,
  complianceCalendar: complianceCalendarSlice.reducer,
  helpModule: helpModuleSlice.reducer,
  scheduling: schedulingSlice.reducer,
  notification: notificationSlice.reducer,
  fixedAssetRegister: fixedAssetRegisterSlice.reducer,
  mySpace: mySpaceSlice.reducer,
  hrms: hrmsSlice.reducer,
  sopModule: sopModuleSlice.reducer,
  thinksToDo: thinksToDoSlice.reducer,
  expenseManagement: expenseManagementSlice.reducer,
});

export type RootState = ReturnType<typeof reducers>;
